import { getField, updateField } from 'vuex-map-fields';
import audit from '@/services/api/audit';

const defaultComment = () => {
    return {
        content: null,
        level: null
    };
};

export default {
    namespaced: true,
    state: {
        comment: defaultComment(),
        commentsList: null,
        allComments: [],
        auditExpanded: true
    },
    getters: {
        getField,
        getAllComments: (state) => state.allComments,
        getAuditExpand: (state) => state.auditExpanded,
        getGiftGivingReport: (state, getters, rootState, rootGetters) =>
            rootGetters['family/getFamily']?.gift_giver?.gift_giving_report
    },
    mutations: {
        updateField,
        clearComment (state) {
            state.comment = defaultComment();
        },
        setCommentsList (state, payload) {
            state.commentsList = payload;
        },
        pushCommentToList (state, payload) {
            state.commentsList.unshift(payload);
        },
        setAllAuditComments (state, payload) {
            state.allComments = payload;
        },
        clearAllComments (state) {
            state.allComments = [];
        },
        setAuditExpand (state, payload) {
            state.auditExpanded = payload;
        }
    },
    actions: {
        sendAuditComment (context, data) {
            data.data = {
                ...context.state.comment
            };
            if (data.isGift) {
                return audit.sendGiftAuditComment(data);
            }
            return audit.sendAuditComment(data);
        },
        getAuditComment (context, payload) {
            context.commit('clearComment');
            if (payload.params.sheetType === 'gift_giving_report') {
                let giftGivingReportAuditComments = null;
                const { getGiftGivingReport } = context.getters;
                if (
                    Boolean(getGiftGivingReport) &&
          'gift_giving_report_audit_comments' in getGiftGivingReport
                ) {
                    giftGivingReportAuditComments =
            context.rootGetters['family/getFamily'].gift_giver.gift_giving_report
                .gift_giving_report_audit_comments;
                }
                context.commit('sheet/setSheetAuditComments', giftGivingReportAuditComments, { root: true });
            } else {
                const comment = context.rootGetters['family/getFamily'].sheets.filter(
                    (el) => el.sheet_type === payload.params.sheetType
                );
                context.commit(
                    'sheet/setSheetAuditComments',
                    comment.length > 0 ? comment[0].sheet_audit_comments : [],
                    { root: true }
                );
            }
        },
        getAllAuditComments (context, sheetType = null) {
            context.commit('clearAllComments');
            let comments;
            let giftAuditComments = null;
            const { getGiftGivingReport } = context.getters;

            if (
                Boolean(getGiftGivingReport) &&
        'gift_giving_report_audit_comments' in getGiftGivingReport
            ) {
                giftAuditComments =
          context.rootGetters['family/getFamily'].gift_giver.gift_giving_report
              .gift_giving_report_audit_comments;
            }
            if (sheetType && sheetType === 'gift_giving_report') {
                comments = [
                    {
                        sheet_type: sheetType,
                        data: giftAuditComments
                    }
                ];
            } else {
                comments = context.rootGetters['family/getFamily'].sheets.map((el) => ({
                    sheet_type: el.sheet_type,
                    data: el.sheet_audit_comments
                }));
                if (
                    Boolean(getGiftGivingReport) &&
          'gift_giving_report_audit_comments' in getGiftGivingReport
                ) {
                    comments.push({
                        sheet_type: 'gift_giving_report',
                        data: giftAuditComments
                    });
                }
            }
            context.commit('setAllAuditComments', comments);
            return comments;
        },
        sendToAreaAudit (context, id) {
            return audit.sendToAreaAudit(id);
        },
        sendToAreaCorrection (context, id) {
            return audit.sendToAreaCorrection(id);
        },
        sendToNationalAudit (context, id) {
            return audit.sendToNationalAudit(id);
        },
        getAuditComments (context, payload) {
            context.commit('setCommentsList', payload.comments);
        },
        publishSheets (context, id) {
            return audit.publishSheets(id);
        },
        sendToNationalCorrection (context, id) {
            return audit.sendToNationalCorrection(id);
        },
        sendToNationalCorrectionVolunteer (context, id) {
            return audit.sendToNationalCorrectionVolunteer(id);
        },
        sendGiftToAreaAudit (context, data) {
            return audit.sendGiftToAreaAudit(data);
        },
        sendGiftToAreaCorrection (context, data) {
            return audit.sendGiftToAreaCorrection(data);
        },
        sendGiftToNationalAudit (context, data) {
            return audit.sendGiftToNationalAudit(data);
        },
        sendGiftToNationalCorrection (context, data) {
            return audit.sendGiftToNationalCorrection(data);
        },
        sendGiftToNationalCorrectionVolunteer (context, data) {
            return audit.sendGiftToNationalCorrectionVolunteer(data);
        },
        sendGiftToGiftGiver (context, data) {
            return audit.sendGiftToGiftGiver(data);
        },
        saveAuditExpand (context, data) {
            if (data.hasPermission) {
                localStorage.setItem('comments-hidden', data.isHidden);
            }
        },
        checkForAuditExpand (context) {
            const isHidden = localStorage.getItem('comments-hidden');
            if (isHidden === 'true') {
                context.commit('setAuditExpand', !isHidden);
            } else {
                context.commit('setAuditExpand', true);
            }
        }
    }
};
